import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    fetchMoreError: string;
    reload: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message when loading more notifications fails */
            fetchMoreError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LoadingMoreIndicatorError.fetchMoreError?c=2ow1r6gxh4wz0", defaultMessage: "Failed to load more notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to reload the page */
            reload: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LoadingMoreIndicatorError.reload?c=3apt6oncaajjc", defaultMessage: "Reload" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
